/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@lm-nx-frontend/lm-inf-core';
import { IconModule, SplitViewModule } from '@lm-nx-frontend/lm-inf-ui';
import { MessageModule } from '../message/message.module';
import { CardComponent } from './card.component';
import { PopoverModule } from '@lm-nx-frontend/lm-inf-ui';
/**
 * Provides a reusable card UI component for the organization split views.
 *
 * The component does not intend to provide a complete set of card features, it's just
 * a reusable component inside the organization UI.
 */
@NgModule({
  imports: [
    CommonModule,
    SplitViewModule,
    RouterModule,
    I18nModule,
    IconModule,
    UrlModule,
    MessageModule,
    PopoverModule,
  ],
  declarations: [CardComponent],
  exports: [CardComponent],
})
export class CardModule {}
